import { createAuthGuards } from '@platform/keycloak-react-auth';
import { projectBrowserAuthorization } from '@omniwound/auth-contract';

import env from '@/config/env';

const guards = createAuthGuards(env.auth);

export const { requireRoles, requireAuthentication, keycloak } = guards;

export function useAuth() {
  const auth = guards.useAuth();
  const authorization = projectBrowserAuthorization({
    realmRoles: auth.realmRoles,
    resourceRoles: auth.resourceRoles,
  });

  return { ...auth, ...authorization };
}
